import { useTheme } from "@emotion/react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { Controller, useForm } from "react-hook-form";
import constants from "../constants";
import useCurrentUserQuery from "../hooks/auth/useCurrentUserQuery";
import useUpdateCurrentUserMutation from "../hooks/auth/useUpdateCurrentUserMutation";
import useI18nContext from "../hooks/general/useI18nContext";
import Form from "./form/Form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FormSelectField from "./form/FormSelectField";
import FormTextField from "./form/FormTextField";
import firebase from 'firebase/app';

const schema = yup
  .object({
    description: yup.string().required(),
    date: yup.string().required(),
    total: yup.number().positive().required(),
  })
  .required();

export default function ActivityForm({
  onCancel,
  defaultValues,
  onSubmit,
  isLoading,
}) {
  const { data: currentUserRegion } = useCurrentUserQuery({
    select: (v) => v?.region,
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { mutateAsync: mutateUserAsync, isLoading: isMutatingUserAsync } =
    useUpdateCurrentUserMutation({
      onSuccess: () => alert("succes"),
    });
  const { spacing } = useTheme();
  const { t } = useI18nContext();

  const typeValue = watch("type");
  const activityTypeString = constants.ACTIVITY_TYPES.find(
    (v) => v.value === typeValue
  )?.label;
  const OLD_PEOPLE_INDEX = 4;
  const MILUIM_INDEX = 5;
  return (
    <>
      <Form
        onCancel={onCancel}
        isLoading={isLoading}
        onSubmit={handleSubmit((values) => {
          const parsedFields = { ...values, type: activityTypeString };
          onSubmit(parsedFields);
        })}
      >
        <FormControl disabled={!!currentUserRegion}>
          <InputLabel id="demo-simple-select-label">{t?.region}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={currentUserRegion}
            label={t?.region}
            onChange={(e) => mutateUserAsync({ region: e.target.value })}
          >
            {constants.REGIONS?.map((region) => (
              <MenuItem dir="rtl" value={region}>
                {region}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{t?.regionChangeAdmin}</FormHelperText>
        </FormControl>

        <br />
        <FormSelectField
          name="type"
          options={constants.ACTIVITY_TYPES}
          control={control}
        />

        {typeValue === OLD_PEOPLE_INDEX ? (
          <>
            <FormTextField
              control={control}
              name="oldPersonName"
              label={t?.oldPersonName}
              fullWidth
              error={!!errors?.oldPersonName}
              helperText={errors?.oldPersonName?.message}
              required
            />
          </>
        ) : null}

        {typeValue === MILUIM_INDEX ? (
          <>
            <a
              href={"https://youtu.be/FFCx0WqRCJQ"}
              target="_blank" // Opens the link in a new tab
              rel="noopener noreferrer" // Recommended for security reasons when using target="_blank"
              style={{
                color: 'blue', // Set the default color to blue
                textDecoration: 'none', // Remove underlines, if desired
              }}
              onClick={(e) => {
                e.target.style.color = 'purple'; // Change color to purple on click
              }}
            >
              {t?.link3010path}
            </a>
          </>
        ) : null}

        {typeValue === MILUIM_INDEX ? (
          <>
            <FormTextField
              control={control}
              name="link3010"
              label={t?.link3010}
              fullWidth
              error={!!errors?.link3010}
              helperText={errors?.link3010?.message}
              required
            />
          </>
        ) : null}

        <FormTextField
          control={control}
          name="description"
          label={t?.description}
          fullWidth
          multiline
          rows={4}
          error={!!errors?.description}
          helperText={errors?.description?.message}
        />
        <Controller
          control={control}
          name="total"
          render={({ field }) => (
            <TextField
              style={{ marginLeft: spacing(2) }}
              error={!!errors?.total}
              helperText={errors?.total?.message}
              label={t?.totalHours}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="date"
          render={({ field }) => (
            <TextField
              fullWidth
              error={!!errors?.date}
              helperText={errors?.date?.message}
              
              type="date"
              {...field}
            />
          )}
        />
      </Form>
    </>
  );
}
